import { useCallback } from 'preact/hooks';

import type { Message } from '../types/messages';
import { getMessageType } from '../utils';

/** Работа с CSAT блоками в виджете */
export const useWidgetCsat = () => {
  /** Заблокировать кнопки причины оценки, если причина была введена самостоятельно */
  const disableLatestCsatButtons = useCallback((messageList: Message[]) => {
    const lastMessage = messageList[messageList.length - 1];

    if (!lastMessage) {
      return [];
    }

    const { isCsatReasonRequest } = getMessageType(lastMessage);

    if (isCsatReasonRequest) {
      const lastMessageIndex = messageList.indexOf(lastMessage);
      return messageList.map((item, index) => {
        if (index === lastMessageIndex) {
          return {
            ...item,
            buttonsDisabled: true,
          };
        } else {
          return item;
        }
      });
    }

    return messageList;
  }, []);

  return {
    disableLatestCsatButtons,
  };
};
